import { Component } from 'react';
import FormCardContainer from './components/container/FormCardContainer';
class FormComponent extends Component {
    render() {
        let { _pageScope, moduleId, ...others } = this.props;
        return <div className='lowcode-form'>{_pageScope.props.form.createForm(moduleId, others)}</div>;
    }
}

export default FormComponent;
export { FormCardContainer };